import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  nameLabel: {
    id: 'linkCreate.CreateGoal.form.name.label',
    defaultMessage: 'What should we call this?',
    description: 'Label for the name input'
  },
  namePlaceholder: {
    id: 'linkCreate.CreateGoal.form.name.placeholder',
    defaultMessage: 'Enter goal name',
    description: 'Placeholder for the name input'
  },
  nameValidationError: {
    id: 'linkCreate.CreateGoal.form.name.error',
    defaultMessage: 'Name field cannot be empty.',
    description: 'Error displayed when goal name is missing'
  },
  userPermissionError: {
    id: 'linkCreate.CreateGoal.create.permission.error',
    defaultMessage: "You don't have the required permission to create a goal.",
    description: 'Error displayed when attempting to create a goal when user does not have the required permissions'
  },
  connectionError: {
    id: 'linkCreate.CreateGoal.create.network.error',
    defaultMessage: 'Connection failed',
    description: 'Error displayed when a server request fails'
  },
  goalOwnerLabel: {
    id: 'Goals.GoalCreationModal.label.owner-selection-title',
    defaultMessage: 'Who is the full time owner?',
    description: 'The full time owner of the goal to be created'
  },
  goalOwnerPickerPlaceholder: {
    id: 'Goals.GoalCreationModal.label.owner-picker-placeholder',
    defaultMessage: 'Enter person',
    description: 'Placeholder to prompt the user to pick the full time owner of the goal to be created'
  },
  ownerValidationError: {
    id: 'linkCreate.CreateGoal.form.owner.error',
    defaultMessage: 'Owner field cannot be empty.',
    description: 'Error displayed when an owner is missing'
  },
  goalCreationError: {
    id: 'inkCreate.CreateGoal.create.error',
    defaultMessage: 'Could not create goal',
    description: 'Error when creating a goal'
  },
  goalDateLabel: {
    id: 'Goals.GoalCreationModal.label.date-selection-title',
    defaultMessage: 'What date are we targeting?',
    description: 'The date of the goal we are creating'
  },
  goalDatePlaceholder: {
    id: 'Goals.GoalCreationModal.label.date-selection-placeholder',
    defaultMessage: 'Pick a date',
    description: 'Placeholder message prompting user to pick a date'
  }
});